// extracted by mini-css-extract-plugin
module.exports = {"container":"Map_container__Bv9KD","map":"Map_map__7VPI3"};